import { Components, Theme } from '@mui/material';

export const MuiTablePagination: Components<Theme>['MuiTablePagination'] = {
  defaultProps: {
    nextIconButtonProps: {
      size: 'small',
    },
    backIconButtonProps: {
      size: 'small',
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.table.background,
    }),
    toolbar: {
      // This is approximately the height of the other size=small header row
      minHeight: 36,
    },
    input: ({ theme }) => ({
      backgroundColor: theme.featureFlags.panwRebrandStubYear ? 'transparent' : undefined,
    }),
    selectRoot: ({ theme }) => ({
      backgroundColor: theme.featureFlags.panwRebrandStubYear ? 'transparent' : undefined,
    }),
    select: ({ theme }) => ({
      ...theme.typography.body2,
      backgroundColor: theme.featureFlags.panwRebrandStubYear ? 'transparent' : undefined,
    }),
  },
};
